/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Header_Firstseen1Inputs */

const id_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertama kali dilihat`)
};

const ms_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dilihat kali pertama`)
};

const da_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set første gang`)
};

const de_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum ersten Mal gesehen`)
};

const en_us2_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First seen`)
};

const es_es2_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista por primera vez`)
};

const es_mx2_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista por primera vez`)
};

const fil_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unang nakita`)
};

const fr_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vu pour la première fois`)
};

const it_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visto per la prima volta`)
};

const hu_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Első észlelés`)
};

const nl_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eerste keer gezien`)
};

const no_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sett første gang`)
};

const pl_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Po raz pierwszy`)
};

const pt_br2_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visto pela primeira vez`)
};

const pt_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visto pela primeira vez`)
};

const ro_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Văzut prima dată`)
};

const fi_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Havaittu ensimmäisen kerran`)
};

const sv_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sågs första gången`)
};

const vi_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thấy lần đầu`)
};

const tr_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk görülme`)
};

const cs_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poprvé zaznamenán`)
};

const bg_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видяна за първи път`)
};

const ru_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Впервые замечен`)
};

const uk_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вперше побачено`)
};

const ar_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شوهد لأول مرة`)
};

const hi_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहली बार देखा गया`)
};

const th_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พบครั้งแรก`)
};

const ja_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`初回確認`)
};

const zh_cn2_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首次发现`)
};

const zh_hant1_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首次發現`)
};

const ko_builds_header_firstseen1 = /** @type {(inputs: Builds_Header_Firstseen1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`처음 확인됨`)
};

/**
* | output |
* | --- |
* | "First seen" |
*
* @param {Builds_Header_Firstseen1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_header_firstseen1 = /** @type {((inputs?: Builds_Header_Firstseen1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Header_Firstseen1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_header_firstseen1(inputs)
	if (locale === "ms") return ms_builds_header_firstseen1(inputs)
	if (locale === "da") return da_builds_header_firstseen1(inputs)
	if (locale === "de") return de_builds_header_firstseen1(inputs)
	if (locale === "en-US") return en_us2_builds_header_firstseen1(inputs)
	if (locale === "es-ES") return es_es2_builds_header_firstseen1(inputs)
	if (locale === "es-MX") return es_mx2_builds_header_firstseen1(inputs)
	if (locale === "fil") return fil_builds_header_firstseen1(inputs)
	if (locale === "fr") return fr_builds_header_firstseen1(inputs)
	if (locale === "it") return it_builds_header_firstseen1(inputs)
	if (locale === "hu") return hu_builds_header_firstseen1(inputs)
	if (locale === "nl") return nl_builds_header_firstseen1(inputs)
	if (locale === "no") return no_builds_header_firstseen1(inputs)
	if (locale === "pl") return pl_builds_header_firstseen1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_header_firstseen1(inputs)
	if (locale === "pt") return pt_builds_header_firstseen1(inputs)
	if (locale === "ro") return ro_builds_header_firstseen1(inputs)
	if (locale === "fi") return fi_builds_header_firstseen1(inputs)
	if (locale === "sv") return sv_builds_header_firstseen1(inputs)
	if (locale === "vi") return vi_builds_header_firstseen1(inputs)
	if (locale === "tr") return tr_builds_header_firstseen1(inputs)
	if (locale === "cs") return cs_builds_header_firstseen1(inputs)
	if (locale === "bg") return bg_builds_header_firstseen1(inputs)
	if (locale === "ru") return ru_builds_header_firstseen1(inputs)
	if (locale === "uk") return uk_builds_header_firstseen1(inputs)
	if (locale === "ar") return ar_builds_header_firstseen1(inputs)
	if (locale === "hi") return hi_builds_header_firstseen1(inputs)
	if (locale === "th") return th_builds_header_firstseen1(inputs)
	if (locale === "ja") return ja_builds_header_firstseen1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_header_firstseen1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_header_firstseen1(inputs)
	return ko_builds_header_firstseen1(inputs)
});
export { builds_header_firstseen1 as "builds.header.firstSeen" }